import React from 'react';
import { Box } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import useDrawer from '../../hooks/useDrawer';

/**
 * MainContentLayout component that wraps main content and adjusts positioning
 * based on sidebar state. Handles both desktop and mobile layouts.
 * 
 * Uses a pure flexbox approach without margins for better layout control.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render
 * @returns {JSX.Element} MainContentLayout component
 */
const MainContentLayout = ({ children }) => {
  // Get drawer state from useDrawer hook
  const { isDesktop } = useDrawer();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      component="main"
      id="main-content"
      sx={{
        paddingTop: 'var(--topnavbar-height)', // Offset for the fixed AppBar height
        // paddingBottom: isMobile ? 'var(--bottomnavbar-height)' : 0, // Offset for bottom navigation on mobile (standard BottomNavigation height)
        flexGrow: 1,
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
      }}
    >
      {children}
    </Box>
  );
};

export default MainContentLayout;
